import s from './User.module.css';
import React from "react";
import UserImage from "@common/Chat/components/UserImage/UserImage";
import {useAddAlert} from "@/hooks/useAddAlert";
import {openPrivateChat} from "@common/Chat/helpers/openPrivateChat";
const User = ({user, setPage, activeUsers}) => {
    const isUserOnline = activeUsers.find(id => id === user.id)
    const addAlert=useAddAlert();
    const save =(e) => {
        if((user.type === 'group' || user.type === 'support') && !!user?.id){
           setPage('inChat', user?.id) 
        }
        else{
            // Чат не создаём: открываем существующий или пустой диалог до первого сообщения
            openPrivateChat({user, changePage: setPage})
                .catch((error) => addAlert({text: error?.message}))
        }
    }
    return (
        <div className={s.user} onClick={(e) => save(e)}>
            <div className={s.photo}>
                <UserImage path={user.avatar_path}/>
                {isUserOnline && <div className={s.isOnline}></div>}
            </div>

            <div className={s.name}> 
                {user.name}
                {!!user?.statusLabel?.trim() && <span style={{color: 'var(--color-text-soft)'}}> ({user?.statusLabel})</span>}
            </div>
        </div>
    )
}

export default User;